import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./auth.guard";
import { HomeComponent } from "./pages/home/home.component";
import { LandingComponent } from "./pages/landing/landing.component";
import { MymissionsComponent } from "./pages/mymissions/mymissions.component";
import { InventoryComponent } from "./pages/inventory/inventory.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { LeaderboardComponent } from "./pages/leaderboard/leaderboard.component";
import { MyitemsComponent } from "./pages/myitems/myitems.component";
import { RewardsComponent } from "./pages/rewards/rewards.component";
import { AuctionhouseComponent } from "./pages/auctionhouse/auctionhouse.component";


const routes: Routes = [
  { path: "", redirectTo: "landing", pathMatch: "full" },
  { path: "dashboard", component: HomeComponent },
  { path: "landing", component: LandingComponent },
  { path: "leaderboard", component: LeaderboardComponent },
  { path: "missions", component:MymissionsComponent},
  { path: "shop", component:InventoryComponent},
  { path: "profile", component:ProfileComponent},
  { path: "inventory", component:MyitemsComponent},
  { path:"rewards", component:RewardsComponent},
  { path:"dealer", component:AuctionhouseComponent}
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: []
})
export class AppRoutingModule { }
